var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92308 4.75V2.875C7.92308 2.37772 8.12569 1.90081 8.48633 1.54917C8.84698 1.19754 9.33612 1 9.84615 1H19.0769C19.587 1 20.0761 1.19754 20.4367 1.54917C20.7974 1.90081 21 2.37772 21 2.875V14.125C21 14.6223 20.7974 15.0992 20.4367 15.4508C20.0761 15.8025 19.587 16 19.0769 16H9.84615C9.33612 16 8.84698 15.8025 8.48633 15.4508C8.12569 15.0992 7.92308 14.6223 7.92308 14.125V12.25M4.84615 12.25L1 8.5L4.84615 4.75M1 8.5H14.125",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitnew);
export default __webpack_public_path__ + "static/media/exit new.1663b77dcc164b1a7d34ec17a10cdbae.svg";
export { ForwardRef as ReactComponent };